export class Question {
  body!: string
  user_id!: string
  model!: string
  thread_id!: string
  question_id?: string
}